import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Auth from "./Context/auth/authState";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
//require("dotenv").config();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Auth>
    <App />
    <ToastContainer />
  </Auth>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
